// Service to share the composed room image and user details
// Endpoint expects multipart/form-data with fields:
// - name (text)
// - email (text)
// - contact_number (text)
// - toc (boolean as string 'true'|'false')
// - marketing (boolean as string 'true'|'false')
// - share (file)

const API_BASE_URL = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_BASE_URL)
  ? process.env.REACT_APP_API_BASE_URL.replace(/\/$/, '')
  : 'https://duluxcoloursoftheworld.com/api/v1';

export async function shareModel({ name, email, contactNumber, pin, toc, marketing, file }) {
  const form = new FormData();
  form.append('name', name || '');
  form.append('email', email || '');
  form.append('contact_number', contactNumber || '');
  if (typeof pin !== 'undefined') form.append('pin', pin || '');
  // Send booleans as strings to be explicit
  if (typeof toc !== 'undefined') form.append('toc', String(!!toc));
  if (typeof marketing !== 'undefined') form.append('marketing', String(!!marketing));
  if (file) form.append('share', file);

  const res = await fetch(`${API_BASE_URL}/share`, {
    method: 'POST',
    body: form,
  });

  let data = null;
  try {
    data = await res.json();
  } catch (_) {}

  if (!res.ok) {
    const message = data?.message || `Failed to share (HTTP ${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data || { status: 'Success', message: 'Successfully Shared Model' };
}

const ShareService = { shareModel };
export default ShareService;

